<template>
  <div class="page-container">
    <Filter ref="filterRef" :params="params" @search="searchData">
      <template #handle>
        <el-form-item>
          <el-button v-show="authList.includes('cloneRecord:createTask')" type="primary" @click="setOtaIsShow">{{$t('process.cloningrecord.cloningIssued')}}</el-button>
        </el-form-item>
      </template>
    </Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column prop="code" :label="$t('process.cloningrecord.cloneNumber')" />
      <el-table-column prop="robotSn" :label="$t('process.cloningrecord.targetRobotCode')" />
      <el-table-column prop="cabinetSn" :label="$t('process.cloningrecord.targetControlCabinetCode')" />
      <el-table-column prop="cabinetSn" :label="$t('process.cloningrecord.targetControlCabinetCode')">
        <template #default="scope">
          <span v-if="scope.row.cabinetSn?.length > 4 && ![undifined, 'undifined', 'Invalid-ID'].includes(scope.row.cabinetSn)">{{scope.row.cabinetSn}}</span>
          <el-popover
            v-else
            placement="top-start"
            :width="400"
            trigger="hover"
            title=""
          >
            <template #default>
              <el-descriptions title="" column="1" border>
                <el-descriptions-item :label="$t('error.alarm.reportinformation')">{{scope.row.cabinetSN}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.solution')">{{$t('error.alarm.solutionInfo')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method1')">{{$t('error.alarm.methodInfo1')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method2')">{{$t('error.alarm.methodInfo2')}}</el-descriptions-item>
              </el-descriptions>
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{ $t('error.alarm.pendingReport') }}
                <i class="el-icon-warning" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="programName" :label="$t('collect.messagelist.programName')" />
      <el-table-column prop="programPackageName" :label="$t('process.cloningrecord.processName')" />
      <el-table-column prop="programFileName" :label="$t('process.cloningrecord.processProgramFile')" show-overflow-tooltip/>
      <el-table-column prop="configCode" :label="$t('process.cloningrecord.processConfiguration')" />
      <!-- <el-table-column prop="configList" :label="$t('process.cloningrecord.processConfigFile')" /> -->
      <el-table-column prop="configList" :label="$t('process.cloningrecord.processConfigFile')" >
        <template #default="scope">
          <span v-if="scope.row.configList">
            {{
              scope.row.configList?.map(item=> {
                const foundItem = configTypeLists.find(type => type.value === item)
                return foundItem ? foundItem.label : item; // 如果未找到，保留原值
              }).join(",")
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('process.cloningrecord.cloneStatus')" >
        <template #default="scope">
          <span>{{taskStatus[scope.row.taskStatus]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" :label="$t('activity.list.creator')" />
      <el-table-column prop="createTime" :label="$t('process.cloningrecord.cloneTime')" />
    </Table>
  </div>
  <el-dialog
    :title="$t('process.cloningrecord.newCloneTask')"
    v-model="dialogFormVisible"
    destroy-on-close
    :modal="true"
    :append-to-body="true"
    width="60%"
  >
      <el-form
        ref="detailformRef"
        class="dialog-form"
        :model="detailform"
        :rules="detailformRules"
        :label-width="curLang == 'zh-CN' ? '100px' : '210px'"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="desc_title">{{$t('process.cloningrecord.cloneProcessProgram')}}</div>
            <el-form-item :label="$t('process.cloningrecord.processProgramLibrary')" prop="programId">
              <el-select v-model="detailform.programId" :placeholder="$t('process.cloningrecord.processProgramLibrary')" @change="(val)=>onCloneChange(val,0)" filterable remote clearable>
                <el-option
                  v-for="(item) in cloneProgramList"
                  :key="item.id.toString()"
                  :label="`${item.name}（${item.robotSn}${item.cabinetSn ? '_'+item.cabinetSn: ''}）`"
                  :value="item.id.toString()"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('collect.messagelist.fileName')" prop="programFileName">
              {{detailform.programFileName}}
            </el-form-item>
            <el-form-item :label="$t('process.cloningrecord.fileSize')" prop="programFileSize">
              {{detailform.programFileSize}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="desc_title">{{$t('process.cloningrecord.cloneProcessConfig')}}</div>
            <el-form-item :label="$t('process.cloningrecord.processConfigLibrary')" prop="configId">
              <el-select v-model="detailform.configId" :placeholder="$t('process.cloningrecord.processProgramLibrary')"  @change="(val)=>onCloneChange(val,1)"  filterable remote clearable>
                <el-option
                  v-for="(item) in cloneConfigList"
                  :key="item.id.toString()"
                  :label="`${item.name}（${item.robotSn}${item.cabinetSn ? '_'+item.cabinetSn: ''}）`"
                  :value="item.id.toString()"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" prop="configList">
              <el-checkbox-group v-model="detailform.configList">
                <el-checkbox :label="$t('service.version.controller')" :disabled="!configList.includes('控制器')"></el-checkbox>
                <el-checkbox :label="$t('process.cloningrecord.ioName')" :disabled="!configList.includes('I/O名称')"></el-checkbox>
                <el-checkbox :label="$t('process.cloningrecord.extendedIO')" :disabled="!configList.includes('扩展I/O')"></el-checkbox>
                <el-checkbox :label="$t('process.cloningrecord.systemVariables')" :disabled="!configList.includes('系统变量')"></el-checkbox>
                <el-checkbox :label="$t('process.cloningrecord.safetyZone')" :disabled="!configList.includes('安全区域')"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!-- <el-form-item :label="$t('process.cloningrecord.fileSize')" prop="configFileSize">
              {{detailform.configFileSize}}
            </el-form-item> -->
            <el-form-item :label="$t('process.cloningrecord.fileSize')" prop="configFileSize">
              {{
                detailform.source == 1 ? getSum() : detailform.configFileSize
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <div class="desc_title">{{$t('process.cloningrecord.selectTargetRobot')}}<el-button style="margin-left: 12px;" size="small" type="primary" @click="addData">{{$t('status.largescreenm.addNewRow')}}</el-button>
        </div>
        <el-form-item label="" prop="file" label-width="0px">
          <el-table :data="detailform.robotList" max-height="250">
            <el-table-column :width="curLang == 'zh-CN' ? '80px' : '120px'"  :label="$t('activity.list.serialNo')" align="center">
              <template #default="scope">{{scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column prop="robotSn" :label="$t('activity.packetjoin.robotCode')" align="center">
                <template #default="scope">
                  <el-form-item label="" :prop="`robotList.${scope.$index}.robotSn`" :rules="detailformRules.robotSn" >
                    <el-select v-model="scope.row.robotSn" :placeholder="$t('process.cloningrecord.sourceRobotCode')" :remote-method="robotSnQuery"  @change="(val)=>onRobotChange(val,scope.row)" filterable remote clearable>
                      <el-option
                        v-for="(item) in robotSnList"
                        :key="item.robotId"
                        :label="item.robotId"
                        :value="item.robotId"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>
            </el-table-column>
            <el-table-column prop="cabinetSn" :label="$t('collect.healthscorelist.ctrlCabCode')" align="center"/>
            <el-table-column prop="status" :label="$t('points.exchange.status')" align="center" width="200">
                <template #default="scope">
                {{ statusList[scope.row.status] }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('activity.list.operation')" align="center" width="200">
              <template #default="scope">
                <el-button size="small" type="primary" @click="deleteRobotInfo(scope)">{{$t('activity.packetjoin.delete')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" type="primary" @click="openSubmit"
          >{{$t('activity.list.confirm')}}</el-button
        >
      </template>
  </el-dialog>
  <el-dialog
    :title="$t('process.cloningrecord.confirmTitle')"
    v-model="dialogVisible"
    destroy-on-close
    :modal="true"
    :append-to-body="true"
    width="60%"
  >
    <div class="section-title">{{$t('process.cloningrecord.confirmMessage')}}</div>
      <el-table :data="detailform.robotList" max-height="200" :border="none">
        <el-table-column :width="curLang == 'zh-CN' ? '80px' : '120px'" :label="$t('activity.list.serialNo')" align="center">
          <template #default="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column prop="robotSn" :label="$t('activity.packetjoin.robotCode')" align="center"/>
        <el-table-column prop="cabinetSn" :label="$t('collect.healthscorelist.ctrlCabCode')" align="center"/>
        <el-table-column prop="status" :label="$t('points.exchange.status')" align="center">
            <template #default="scope">
            {{ statusList[scope.row.status] }}
          </template>
        </el-table-column>
      </el-table>
      <div class="clone-content">
      <div class="section-title">{{$t('process.cloningrecord.contentLabel')}}</div>
      <el-descriptions class="margin-top" title="" :column="3" >
        <el-descriptions-item :label="`${$t('process.cloningrecord.processProgramLibrary')}:`">
          <span class="truncate-text" :title="getProgramName(detailform.programId)">
            {{getProgramName(detailform.programId)}}
          </span>
        </el-descriptions-item>
        <el-descriptions-item :label="`${$t('collect.messagelist.fileName')}:`">
          <span class="truncate-text" :title="detailform.programFileName">
            {{detailform.programFileName}}
          </span>
        </el-descriptions-item>
        <el-descriptions-item :label="`${$t('process.cloningrecord.fileSize')}:`">{{detailform.programFileSize}}</el-descriptions-item>
        <el-descriptions-item :label="`${$t('process.cloningrecord.processConfigLibrary')}:`">
          <span class="truncate-text" :title="getConfigName(detailform.configId)">
            {{ getConfigName(detailform.configId) }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item :label="`${$t('process.configtable.configFile')}:`">
          <el-tag style="margin-right: 4px;" v-for="item in detailform.configList" size="small">{{item}}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item :label="`${$t('process.cloningrecord.fileSize')}:`">{{detailform.source == 1 ? getSum() : detailform.configFileSize}}</el-descriptions-item>
      </el-descriptions>
      </div>
      <div class="warning-box">
        <div class="warning-icon">
          <i class="el-icon-warning"></i><i class="fas fa-exclamation-triangle"></i>
        </div>
        <div class="warning-text">
          <strong>{{$t('service.upgrade.warning')}}：</strong>{{$t('service.upgrade.warningCloneInfo')}}
        </div>
      </div>
      <el-row :gutter="20" style="width: 500px;margin: 0 auto;">
        <el-col :span="14">
          <el-input :placeholder="$t('views.login.enterVerificationCode')" v-model="detailform.captcha" clearable>
            <!-- <template #prefix>
              <span class="icon iconfont icon-ota-anquan"></span>
            </template> -->
          </el-input>
        </el-col>
        <el-col :span="10" @click="validCode">
          <img class="valid-img" :src="detailform.captchaImg" alt="" srcset="">
        </el-col>
      </el-row>
      <template #footer>
        <el-button size="small" type="primary" @click="editSubmit"
          >{{$t('activity.list.confirm')}}</el-button
        >
      </template>
  </el-dialog>
</template>

<script>
import { request } from '@/utils/request'
import { common } from '../../common/mixin'
import Table from '@/components/table/index'
import Filter from '@/components/table/filter'
import { robotStatusMap } from "@/common/constant";
import dayjs from 'dayjs'
import { useRoute } from 'vue-router'
import { ElMessage, } from "element-plus";
import { computed } from "vue";
import { useStore } from "vuex"
// import { useI18n } from 'vue-i18n'
// const { t } = useI18n()
export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  data () {
    const store = useStore()
    const route = useRoute()
    const programId = route.query.programId
    const configId = route.query.configId
    const programName = route.query.programName
    const configCode = route.query.configCode
    const createTime = route.query.createTime
    const taskStatus = [
      {
        label: this.$t('process.cloningrecord.notStarted'),
        value: '0'
      },
      {
        label: this.$t('error.errorlog.waitingForRobotResponse'),
        value: '1'
      },
      {
        label: this.$t('process.cloningrecord.cloningInProgress'),
        value: '2'
      },
      {
        label: this.$t('process.cloningrecord.cloneCompleted'),
        value: '3'
      },
      {
        label: this.$t('process.cloningrecord.cloneFailed'),
        value: '4'
      }
    ]
    
    const configTypeList = [
      {
        label: this.$t('service.version.controller'),
        value: '控制器',
        fileSize: 4.8
      },
      {
        label: this.$t('process.cloningrecord.ioName'),
        value: 'I/O名称',
        fileSize: 0.7
      },
      {
        label: this.$t('process.cloningrecord.extendedIO'),
        value: '扩展I/O',
        fileSize: 0.6
      },
      {
        label: this.$t('process.cloningrecord.systemVariables'),
        value: '系统变量',
        fileSize: 0.3
      },
      {
        label: this.$t('process.cloningrecord.safetyZone'),
        value: '安全区域',
        fileSize: 0.6
      }
    ]
    return {  
      params: [
        {
          key: 'code',
          value: '',
          label: this.$t('process.cloningrecord.cloneNumber')
        },
        {
          key: 'robotSn',
          value: '',
          label: this.$t('service.upgrade.robotId')
        },
        {
          key: 'programName',
          value: programName,
          label: this.$t('process.cloningrecord.processName')
        },
        {
          key: 'configCode',
          value: configCode,
          label: this.$t('process.cloningrecord.processConfiguration')
        },
        {
          type: 'Select',
          key: 'status',
          value: null,
          label: this.$t('process.cloningrecord.cloneStatus'),
          options: {
            data: taskStatus,
            label: 'label',
            value: 'value'
          }
        },
        {
          type: 'Date',
          key: 'dateRange',
          value: [
            createTime ? dayjs(createTime).format('YYYY-MM-DD') + ' 00:00:00' : dayjs().subtract(6, 'month').format('YYYY-MM-DD') + ' 00:00:00',
            dayjs().format('YYYY-MM-DD') + ' 23:59:59'
          ],
          label: this.$t('process.cloningrecord.cloneDate'),
          options: {
            type: 'datetimerange',
            format: 'YYYY-MM-DD HH:mm:ss',
            'value-format': 'YYYY-MM-DD HH:mm:ss',
            'range-separator': this.$t('activity.detail.to'),
            'start-placeholder': this.$t('activity.list.startDate'),
            'end-placeholder': this.$t('activity.list.endDate'),
            'default-time': [
              new Date(2000, 1, 1, 0, 0, 0),
              new Date(2000, 1, 1, 23, 59, 59)
            ]
          },
        }
      ],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      taskStatus: {0:this.$t('process.cloningrecord.notStarted'),1:this.$t('error.errorlog.waitingForRobotResponse'),2:this.$t('process.cloningrecord.cloningInProgress'),3:this.$t('process.cloningrecord.cloneCompleted'),4:this.$t('process.cloningrecord.cloneFailed')},
      dialogFormVisible: (programId !== undefined  || configId !== undefined) ? true : false,
      detailform: {
        programId: programId,
        configId: configId,
        programFileSize: '',
        programFileName: "",
        configFileSize: '',
        configFileName: "",
        configList: [],
        source: 0,
        robotList: [
          {
            robotSn: '',
            cabinetSn: "",
            status: null
          }
        ],
        captcha: '',
        captchaImg: '',
        captchaKey: '',
      },
      configList: [],
      detailformRules:{
        // programId: {
        //   required: true,
        //   message: '请选择工艺程序库',
        //   trigger: 'change'
        // },
        robotSn: {
          required: true,
          message: this.$t('status.largescreenm.selectRobotCode'),
          trigger: 'change'
        },
        // configList: {
        //   required: true,
        //   message: '请选择工艺配置',
        //   trigger: 'change'
        // },
      },
      detailAddformRules:{
        groupName: {
          required: true,
          message: this.$t('status.largescreenm.enterGroupName'),
          trigger: 'change'
        },
        source: {
          required: true,
          message: this.$t('status.largescreenm.selectSource'),
          trigger: 'change'
        },
        serialNo: {
          required: true,
          message: this.$t('status.largescreenm.selectRobotCode'),
          trigger: 'change'
        },
        robotName: {
          required: true,
          message: this.$t('status.largescreenm.enterRobotName'),
          trigger: 'change'
        },
        power: {
          required: true,
          message: this.$t('status.largescreenm.enterRatedPower'),
          trigger: 'change'
        },
      },
      selectedRow: null,
      robotSnList: [],
      cloneProgramList: [],
      cloneConfigList: [],
      checkList: [],
      statusList: robotStatusMap,
      curLang: computed(() => store.state.lang),
      configTypeLists: configTypeList,
      dialogVisible: false,
      authList: JSON.parse(window.localStorage.getItem('authList'))
    }
  },
  created () {
    this.validCode()
  },
  mounted () {
    this.$refs.filterRef?.searchData()
    this.getCloneProgram()
    this.getCloneConfig()
  },
  methods: {
    getData () {
      request('getCloneTask', {
        ...this.query,
        page: this.page,
        size: this.size,
        startTime: this.query.dateRange?.[0],
        endTime: this.query.dateRange?.[1]
      })
        .then(data => {
          this.tableDataList = data.records
          this.total = parseInt(data.total)
        })
        .catch(error => {
          console.error(error)
        })
    },
    getDataMap () {
      try {
        request('getArea', {
          parentId: 1
        }).then(data => {
          this.provinceList = data
        })
        request('getRobotStatusMap').then(data => {
          this.robotStatusList = data
        })
        request('getIndustryList').then(data => {
          this.industryList = data
        })
      } catch (error) {
        console.log(error)
      }
    },
    searchData (data) {
      this.query = data
      this.getData()
    },
    updatePage (page, size) {
      this.page = page || 1
      this.size = size || 10
      this.getData()
    },
    handleClick (row) {
      this.$router.push({
        path: '/collect/healthScoreTrend',
        query: { robotSn: row.robotSn }
      })
    },
    setOtaIsShow () {
      this.detailform.programId = ''
      this.detailform.configId = ''
      this.dialogFormVisible = true
      this.detailform.configList = []
      this.detailform.robotList = [
        {
          robotSn: '',
          cabinetSn: "",
          status: null
        }
      ]
      this.detailform.programFileSize = ''
      this.detailform.programFileName = ''
      this.detailform.configFileSize = ''
      this.detailform.configFileName = ''
      this.source = 0
      this.configList = []
      this.robotSnList = []
    },
    getCloneProgram () {
      request('getCloneProgram', {
        name: '',
        cabinetSn: "",
        endTime: "",
        page: 1,
        robotSn: "",
        size: 1000,
        startTime: "",
        uploadStatus: "3"
      })
        .then(data => {
          this.cloneProgramList = data.records
          this.cloneProgramList.map(item => item.value = item.id)
          this.$route.query.programId && this.onCloneChange(this.$route.query.programId,0)
        })
        .catch(error => {
          console.error(error)
        })
    },
    getCloneConfig () {
      request('getCloneConfig', {
        name: '',
        cabinetSn: "",
        endTime: "",
        page: 1,
        robotSn: "",
        size: 1000,
        startTime: "",
        uploadStatus: "3"
      })
        .then(data => {
          this.cloneConfigList = data.records
          this.$route.query.configId && this.onCloneChange(this.$route.query.configId,1)
        })
        .catch(error => {
          console.error(error)
        })
    },
    onCloneChange (val,type) {
      if(type){
        this.detailform.configFileSize = this.cloneConfigList.filter(item=> item.id == val)[0]?.fileSize
        this.detailform.configList = this.cloneConfigList.filter(item=> item.id == val)[0]?.configList.split(',') || ['控制器','扩展I/O']
        this.configList = this.cloneConfigList.filter(item=> item.id == val)[0]?.configList.split(',') || ['控制器','扩展I/O']
        this.detailform.source = this.cloneConfigList.filter(item=> item.id == val)[0]?.source
      }else{
        this.detailform.programFileName = this.cloneProgramList.filter(item=> item.id == val)[0]?.fileName
        this.detailform.programFileSize = this.cloneProgramList.filter(item=> item.id == val)[0]?.fileSize
      }
    },
    addData () {
      const data = [{
        status:'',
        cabinetId:'',
        customer:'',
        robotId:'',
        source: '',
        serialNo: ''
      }]
      this.detailform.robotList = [...this.detailform.robotList || [],...data]
    },
    async robotSnQuery (name) {
      try {
        this.robotSnList = []
        const res = await request('getCollectRobot', {robotId: name})
        this.robotSnList = (res.records || []).slice(0, 20)
      } catch (error) {
        console.error(error)
      }
    },
    async openSubmit(){
      if(!(this.detailform.programId || this.detailform.configId)){
        ElMessage({
          showClose: true,
          type: "info",
          message: this.$t('process.cloningrecord.selectAtLeastOne')
        })
        return false
      }
      if(this.detailform.configId && this.detailform.configList.length == 0){
        ElMessage({
          showClose: true,
          type: "info",
          message: this.$t('process.cloningrecord.configSelectionRequired')
        })
        return false
      }
      if(this.detailform.robotList.length == 0){
        ElMessage({
          showClose: true,
          type: "info",
          message: this.$t('process.cloningrecord.selectTargetRobot')
        })
        return false
      }
      this.$refs.detailformRef && await this.$refs.detailformRef.validate()
      this.dialogVisible = true
      this.dialogFormVisible = false
    },
    async editSubmit () {
      if(!(this.detailform.programId || this.detailform.configId)){
        ElMessage({
          showClose: true,
          type: "info",
          message: this.$t('process.cloningrecord.selectAtLeastOne')
        })
        return false
      }
      if(this.detailform.configId && this.detailform.configList.length == 0){
        ElMessage({
          showClose: true,
          type: "info",
          message: this.$t('process.cloningrecord.configSelectionRequired')
        })
        return false
      }
      this.$refs.detailformRef && await this.$refs.detailformRef.validate()
      request('createCloneTask', this.detailform)
        .then(data => {
          this.dialogFormVisible = false
          this.dialogVisible = false
          this.getData();
        })
        .catch(error => {
          console.error(error)
        })
    },
    deleteRobotInfo (scope){
      this.detailform.robotList.splice(scope.$index,1)
    },
    onRobotChange (val,item) {
      const currtRobot = this.robotSnList.filter(it=> it.robotId == val)[0]
      item.cabinetSn = currtRobot.cabinetId
      item.status = currtRobot.status
    },
    getSum(){
      const sum = this.detailform.configList.reduce((sum, item) => {
        const foundItem = this.configTypeLists.find(type => type.value === item);
        return sum + (foundItem ? foundItem.fileSize : 0);
      }, 0).toFixed(2) + 'KB'
      console.log('cwww',sum)
      return sum
    },
    validCode() {
      request('validCode', {})
      .then((data) => {
        this.detailform.captchaImg = data.captcha;
        this.detailform.captchaKey = data.key;
      })
      .catch((error) => {
        console.log(error);
      });
    },
    getProgramName(programId){
      const info = this.cloneProgramList.filter(it => it.id == programId)?.[0]
      return info ? `${info.name}（${info.robotSn}${info.cabinetSn ? '_'+info.cabinetSn: ''}）` : ''
    },
    getConfigName(configId){
      const info = this.cloneConfigList.filter(it => it.id == configId)?.[0]
      return info ? `${info?.name}（${info?.robotSn}${info?.cabinetSn ? '_'+info?.cabinetSn: ''}）` : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.truncate-text {
  display: inline-block;
  max-width: 300px; /* 根据实际需求调整宽度 */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.desc_title{
  position: relative;
  padding-left: 12px;
  margin-bottom: 20px;
  font-size: 18px;
  color: #1677ff;
}
.desc_title::before{
  position: absolute;
  content: ' ';
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background-color: #1677ff;
}
.progress-text {
  font-size: 12px;
}

.clone-content {
  margin-bottom: 32px;
  margin-top: 24px;
}

.section-title {
  color: #2c3e50;
  font-size: 16px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #eef2f7;
  font-weight: 600;
}

.warning-box {
  background-color: #fff8e1;
  border-radius: 12px;
  padding: 20px;
  margin-top: 32px;
  margin-bottom: 32px;
  border-left: 5px solid #ffb74d;
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.warning-icon {
  color: #ff9800;
  font-size: 24px;
  flex-shrink: 0;
}

.warning-text {
  color: #5d4037;
  line-height: 1.6;
  font-size: 15px;
}

:deep(.el-descriptions__label) {
  font-weight: 600;
}

        
</style>